import React, { useEffect, useState } from "react";
import { Popconfirm, Spin, Table, message, Modal } from "antd";
// import Breadcrumb from "../../../../components/common/Breadcrumb";
import { Box, Tabs, Tab, Typography, Paper, Button } from "@mui/material";
import ApiCallService from "../../../../Service/ApiCallService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactTable from "../../../../components/common/ReactTable";
import { usePermission } from "../../../../permissions/usePermission";

const UserProfileVerificationUpdate = () => {
  const [userProfiles, setUserProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [stateMap, setStateMap] = useState({});
  const [districtMap, setDistrictMap] = useState({});
  const { canByKey } = usePermission();
  const canApproveUser = canByKey("USER_MANAGEMENT_USER_APPROVAL_APPROVE_CREATE");
  const canDeclineUser = canByKey("USER_MANAGEMENT_USER_APPROVAL_DECLINE_CREATE");
  const navigate = useNavigate();
  const location = useLocation();
  const fetchUserProfiles = async () => {
    try {
      setLoading(true);
      const response = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/users?profilestatus=pending`
      );
      console.log("Fetched user profiles response:", response);
      setUserProfiles(
        response.data?.data || response.data?.users || response.data || []
      );
    } catch (error) {
      console.error("Error fetching user profiles:", error);
      setLoading(false);
      message.error("Error fetching user profiles")
    } finally {
      setLoading(false);
    }
  };

  const getStateId = (row) => {
    if (typeof row.State === "string") return row.State;
    if (typeof row.state === "string") return row.state;
    return row.State?._id || row.state?._id || "";
  };

  const getDistrictId = (row) => {
    if (typeof row.District === "string") return row.District;
    if (typeof row.district === "string") return row.district;
    return row.District?._id || row.district?._id || "";
  };

  const fetchLocationMaps = async (profiles) => {
    try {
      const uniqueStateIds = Array.from(
        new Set(profiles.map(getStateId).filter(Boolean))
      );

      const statesRes = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/states`
      );
      const states = statesRes?.data || statesRes || [];

      const nextStateMap = {};
      states.forEach((s) => {
        if (s?._id) nextStateMap[s._id] = s.stateName || s.name || "";
      });

      const nextDistrictMap = {};
      for (const stateId of uniqueStateIds) {
        try {
          const districtsRes = await ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/state/${stateId}/district`
          );
          const districts = districtsRes?.data || districtsRes || [];
          districts.forEach((d) => {
            if (d?._id) nextDistrictMap[d._id] = d.districtName || d.name || "";
          });
        } catch (err) {
          console.error("Error fetching districts for state", stateId, err);
        }
      }

      setStateMap(nextStateMap);
      setDistrictMap(nextDistrictMap);
    } catch (err) {
      console.error("Error fetching states/districts", err);
    }
  };

  useEffect(() => {
    fetchUserProfiles();

  }, []);

  useEffect(() => {
    if (userProfiles?.length) {
      fetchLocationMaps(userProfiles).finally(() => setLoading(false));
    }
  }, [userProfiles]);
  console.log("User Profiles: ", userProfiles);

  const handleUpdate = async (id) => {
    try {
      setLoading(true);

      const loginUserId = await localStorage.getItem("userId");

      const res = await ApiCallService.patch(
        `${process.env.REACT_APP_BASE_URL}/user/verifyuser/${id}`,
        { loginUserId }
      );

      if (res) {
        message.success(res.message);
        await fetchUserProfiles();
      }
    } catch (error) {
      setLoading(false);
      console.log("Error ", error)
      message.error(`Error: ${error.message || "Something went wrong"}`);
    }
    setLoading(false);
  };

  const showModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    if (selectedRecord) {
      handleUpdate(selectedRecord._id);
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  // const breadcrumbItems = [
  //   { label: "Nexus", path: "/" },
  //   { label: "VM", path: "/vm/dashboard" },
  //   { label: "Profile Update", path: "/vm/profileupdate" },
  // ];

  const columns = [
    {
      field: "fullName",
      headerName: "Name",
      renderCell: (row) => `${row.userFirstName} ${row.userLastName}`,
      searchKey: (row) =>
        `${row.userFirstName || ""} ${row.userMiddleName || ""} ${row.userLastName || ""}`,
    },
    {
      field: "emailId",
      headerName: "Email",
      disableSort: true,
      renderCell: (row) => row.emailId || "-",
      // disableSearch: true,
    },
    // {
    //   field: "dob",
    //   headerName: "Date of Birth",
    //   disableSort: true,
    //   disableSearch: true,
    //   renderCell: (row) =>
    //     row.dob ? new Date(row.dob).toLocaleDateString() : "–",
    // },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      disableSort: true,
      // disableSearch: true,
    },
    {
      field: "location",
      headerName: "Location",
      disableSort: true,
      renderCell: (row) => {
        const stateId = getStateId(row);
        const districtId = getDistrictId(row);
        const state =
          row.State?.stateName ||
          row.state?.stateName ||
          stateMap[stateId] ||
          row.state?.name ||
          "";
        const district =
          row.District?.districtName ||
          row.district?.districtName ||
          districtMap[districtId] ||
          row.district?.name ||
          "";
        return [state, district].filter(Boolean).join(", ") || "-";
      },
      searchKey: (row) => {
        const stateId = getStateId(row);
        const districtId = getDistrictId(row);
        const state =
          row.State?.stateName ||
          row.state?.stateName ||
          stateMap[stateId] ||
          row.state?.name ||
          "";
        const district =
          row.District?.districtName ||
          row.district?.districtName ||
          districtMap[districtId] ||
          row.district?.name ||
          "";
        return `${state} ${district}`.trim();
      },
    },
    // {
    //   field: "verified",
    //   headerName: "Profile Status",
    //   disableSort: true,
    //   // disableSearch: true,
    //   renderCell: (row) => (
    //     <span
    //       style={{
    //         color: row.verified === "verified" ? "green" : "yellow",
    //         fontWeight: "bold",
    //       }}
    //     >
    //       {row.verified === "verified" ? "Verified" : "Not Verified"}
    //     </span>
    //   ),
    // },
    ...((canApproveUser || canDeclineUser)
      ? [
          {
            field: "actions",
            headerName: "Actions",
            disableSort: true,
            disableSearch: true,
            renderCell: (row) => (
              <>
                <div className="justify-between">
                  <Button
                    variant="contained"
                    onClick={() => handleClick(row._id)}
                    type="primary"
                  >
                    View
                  </Button>
                </div>
              </>
            ),
          },
        ]
      : []),
  ];


  function handleClick(id) {
    navigate(`/profile/${id}`, {
      state: { mode: "view", navigateFrom: location.pathname },
    });
  }


  return (
    <>
      {/* <div>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              display: "inline-block",
              // borderBottom: `3px solid ${theme.palette.primary.main}`,
              mb: 4,
            }}
          >
            Profile Verification
          </Typography>
        </Box>
      </div> */}

      <Box
        sx={{
          // height: "calc(100vh - 180px)",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <Paper
          elevation={3}
          sx={{
            flex: 1,
            width: "100%",
            overflow: "hidden",
            borderRadius: 2,
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
          }}
        > */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
            }}
          >
            <ReactTable
              // title="List of Chapters"
              columns={columns}
              rows={userProfiles}
              rowKey="_id"
              loading={loading}
            />
          </Box>
        {/* </Paper> */}
      </Box>

      {/* <Table dataSource={userProfiles} columns={columns} loading={loading} /> */}




    </>
  );
};

export default UserProfileVerificationUpdate;





